<mat-dialog-content>
    <mat-expansion-panel
        [expanded]="trackingData.length == 0"
        class="mat-elevation-z0"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>Manage Data: {{ bill.measure }}</mat-panel-title>
            <mat-panel-description
                >Tracking Items ({{
                    trackingData.length
                }})</mat-panel-description
            >
        </mat-expansion-panel-header>
        <mat-list *ngIf="hasData(); else empty">
            <div *ngFor="let object of trackingData">
                <h4 matSubheader>
                    <strong>{{ object.name }}</strong>
                </h4>
                <mat-list-item *ngFor="let item of object.items">
                    <h4 matListItemTitle>{{ item.dynamicValue }}</h4>
                    <span matListItemMeta>
                        <button
                            mat-icon-button
                            (click)="removeItem(item, object)"
                            color="primary"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </span>
                </mat-list-item>
            </div>
        </mat-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>
    <div *ngIf="!isSaving; else saving">
        <mat-form-field appearance="outline">
            <mat-label>Tracking Data</mat-label>
            <mat-select
                #trackingSelect
                [value]="selected"
                (selectionChange)="onChange($event.value)"
            >
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let obj of objects" [value]="obj">{{
                    obj.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div [ngSwitch]="selected?.objectType?.name">
            <div *ngSwitchCase="'SelectList'">
                <ng-container
                    *ngTemplateOutlet="selectList; context: selected"
                ></ng-container>
            </div>
            <div *ngSwitchCase="'MultiList'">
                <ng-container *ngTemplateOutlet="multiList"></ng-container>
            </div>
            <div *ngSwitchCase="'TextBox'">
                <ng-container
                    *ngTemplateOutlet="textBox; context: selected"
                ></ng-container>
            </div>
            <div *ngSwitchCase="'BillReference'">
                <ng-container *ngTemplateOutlet="billRef"></ng-container>
            </div>
            <div *ngSwitchCase="'CheckBox'">
                <ng-container
                    *ngTemplateOutlet="checkBox; context: selected"
                ></ng-container>
            </div>
            <div *ngSwitchDefault></div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button
        mat-raised-button
        color="primary"
        (click)="applyItem()"
        [disabled]="isLoading || !isValid || isSaving"
    >
        Apply
    </button>
    <button mat-button [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>

<ng-template #empty>
    <mat-list>
        <mat-list-item>No Tracking Data has been applied</mat-list-item>
    </mat-list>
</ng-template>

<ng-template #saving>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #selectList let-label="name">
    <mat-form-field appearance="outline">
        <mat-label>{{ label }}</mat-label>
        <mat-select
            [(value)]="valueObject"
            (selectionChange)="onSelectChange($event)"
        >
            <mat-option></mat-option>
            <mat-option *ngFor="let item of selected?.values" [value]="item">{{
                item.dynamicValue
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>

<ng-template #multiList>
    <form [formGroup]="searchForm">
        <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input
                matInput
                placeholder="Search"
                formControlName="searchFilter"
            />
        </mat-form-field>
    </form>
    <mat-selection-list
        color="primary"
        (selectionChange)="onSelectionChange($event)"
    >
        <mat-list-option
            *ngFor="
                let item of selected?.values || []
                    | filterBy: 'dynamicValue' : searchFilter
            "
            [selected]="item.active"
            [value]="item"
        >
            {{ item.dynamicValue }}
        </mat-list-option>
    </mat-selection-list>
</ng-template>

<!-- TODO: Create TextBox Metadata to validate -->
<ng-template #textBox let-label="name" let-value="valueString">
    <form [formGroup]="stringForm">
        <mat-form-field appearance="outline">
            <mat-label>{{ label }}</mat-label>
            <input matInput formControlName="valueString" />
        </mat-form-field>
    </form>
</ng-template>

<ng-template #billRef>
    <form [formGroup]="searchForm">
        <mat-form-field appearance="outline">
            <mat-label>Bill Search</mat-label>
            <input
                matInput
                placeholder="AB 1000"
                formControlName="searchFilter"
            />
        </mat-form-field>
        <button mat-raised-button (click)="search()" color="primary">
            Search
        </button>
    </form>
    <mat-action-list>
        <button
            mat-list-item
            *ngFor="let item of billSearchResults"
            (click)="selectBill(item)"
        >
            <strong>{{ item.measure }}</strong>
            ({{ item.sessionYear }}) - {{ item.subject }}
        </button>
    </mat-action-list>
</ng-template>

<ng-template #checkBox let-label="name">
    <mat-form-field appearance="outline">
        <mat-label>{{ label }}</mat-label>
        <mat-select
            [(value)]="valueInt"
            (selectionChange)="onCheckBoxChange($event)"
        >
            <mat-option></mat-option>
            <mat-option value="1">Yes</mat-option>
            <mat-option value="0">No</mat-option>
        </mat-select>
    </mat-form-field>
</ng-template>
